import Vue from 'vue';
import VueRouter from 'vue-router';
import VueAxios from 'vue-axios';
import axios from 'axios';
import VueTelInput from 'vue-tel-input';
import vueCountryRegionSelect from 'vue-country-region-select';
import JsonExcel from "vue-json-excel";
import JwPagination from 'jw-vue-pagination';
import VueLoading from 'vuejs-loading-plugin';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import moment from 'moment';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueApexCharts from 'vue-apexcharts';
import VueGeolocation from 'vue-browser-geolocation';
import GoogleAuth from 'vue-google-oauth2';
// import GoogleOneTap from 'vue-google-one-tap'; // Removed

const options = {
    confirmButtonColor: '#41AA28',
    cancelButtonColor: '#ff7674',
};

Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(VueTelInput);
Vue.use(vueCountryRegionSelect);
Vue.component("downloadExcel", JsonExcel);
Vue.component('jw-pagination', JwPagination);
Vue.use(VueLoading);
Vue.use(VueSweetalert2, options);
Vue.use(VueToast);
Vue.component('apexchart', VueApexCharts);
Vue.use(VueGeolocation);

const gauthOption = {
    clientId: '36667530562-nl7v78qd78rqi1qflaqsl2k3bb970714.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'select_account',
};

Vue.use(GoogleAuth, gauthOption);

import App from './view/App';
import Index from './pages/index';
import Home from './pages/home';
import Users from './users/users';
import Clients from './users/clients';
import Clients2 from './users/clients2';
import Blacklist from './users/blacklist';
import Forget from './pages/forget';
import Password from './pages/password';
import Rates from './settings/rates';
import Safaricom from './credits/safaricom';
import Bonus from './mpesa/bonus';
import Airtel from './credits/airtel';
import Telkom from './credits/telkom';
import Credits from './mpesa/credits';
import B2C from './mpesa/b2clogs';
import Numbers from './settings/numbers';
import Profile from './users/profile';
import AirtelNumbers from './settings/airtelNumbers';
import Search from './users/search';
import Graph from './pages/graph';
import Wallet from './users/wallets';
import Messages from './users/messages';

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', name: 'index', component: Index, meta: { hideNavigation: true } },
        { path: '/home', name: 'home', component: Home },
        { path: '/messages', name: 'messages', component: Messages },
        { path: '/wallets', name: 'wallets', component: Wallet },
        { path: '/graph', name: 'graph', component: Graph },
        { path: '/clients/search', name: 'search', component: Search },
        { path: '/users', name: 'users', component: Users },
        { path: '/airtime-purchase/clients', name: 'clients', component: Clients },
        { path: '/airtime-converts/clients', name: 'clients2', component: Clients2 },
        { path: '/forget', name: 'forget', component: Forget, meta: { hideNavigation: true } },
        { path: '/auth/verify/otp/kmtc', name: 'kmtc', component: Password, meta: { hideNavigation: true } },
        { path: '/rates', name: 'rates', component: Rates },
        { path: '/numbers', name: 'numbers', component: Numbers },
        { path: '/numbers/airtel', name: 'airtelNumbers', component: AirtelNumbers },
        { path: '/safaricom', name: 'safaricom', component: Safaricom },
        { path: '/bonus', name: 'bonus', component: Bonus },
        { path: '/airtel', name: 'airtel', component: Airtel },
        { path: '/telkom', name: 'telkom', component: Telkom },
        { path: '/mpesa/credits', name: 'mpesa-credits', component: Credits },
        { path: '/mpesa/b2c', name: 'mpesa-b2c', component: B2C },
        { path: '/profile', name: 'profile', component: Profile },
        { path: '/blacklist', name: 'blacklist', component: Blacklist },
    ],
});

const app = new Vue({
    el: '#app',
    components: { App },
    router,
});
